<script lang="ts">
	import { page } from "$app/state";
	import { LayoutDashboard, Languages, Settings, Shield } from "@lucide/svelte";
	import { userStore } from "$lib/stores/user";
	import { t } from "svelte-i18n";

	const role = $derived($userStore.user?.role ?? "user");

	const baseLinks = {
		dashboard: { href: "/dashboard", labelKey: "shared.dashboard", icon: LayoutDashboard },
		scripts: { href: "/scripts", labelKey: "shared.scripts", icon: Languages },
		settings: { href: "/settings", labelKey: "nav.settings", icon: Settings },
		admin: { href: "/admin", labelKey: "Admin", icon: Shield },
	};

	const navLinks = $derived.by(() => {
		switch (role) {
			case "admin":
				return [baseLinks.admin, baseLinks.settings];
			case "student":
				return [baseLinks.dashboard, baseLinks.settings];
			default:
				return [baseLinks.dashboard, baseLinks.scripts, baseLinks.settings];
		}
	});

	function isActive(href: string): boolean {
		const path = page.url.pathname;
		if (href === "/dashboard") return path === "/dashboard";
		if (href === "/scripts") return path === "/scripts" || path.startsWith("/scripts/");
		if (href === "/settings") return path === "/settings";
		if (href === "/admin") return path === "/admin" || path.startsWith("/admin/");
		return path === href;
	}
</script>

<nav
	class="fixed bottom-0 left-0 right-0 z-50 flex h-[84px] items-center justify-around border-t border-(--sidebar-border) bg-(--card) shadow-[0_-1px_8px_-2px_rgba(16,24,40,0.08)] pb-[env(safe-area-inset-bottom)] md:hidden"
	role="navigation"
	aria-label={$t('nav.main')}
>
	{#each navLinks as link (link.href)}
		<a
			href={link.href}
			class="flex flex-col items-center justify-center gap-1 rounded-(--radius-m) px-4 py-2 text-[12px] font-medium no-underline transition-colors min-w-0 flex-1
				{isActive(link.href)
				? 'text-(--sidebar-accent-foreground) bg-(--sidebar-accent)'
				: 'text-(--sidebar-foreground) hover:bg-(--sidebar-accent) hover:text-(--sidebar-accent-foreground)'}"
		>
			<link.icon size={22} strokeWidth={1.5} class="shrink-0" />
			<span class="truncate">{link.labelKey.startsWith("shared.") || link.labelKey.startsWith("nav.") ? $t(link.labelKey) : link.labelKey}</span>
		</a>
	{/each}
</nav>
